import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpContextToken } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from "rxjs/operators";

import { AuthService } from 'src/app/_services/auth.service';
import { AlertService } from './alert.service';

/**
 * A request with this set gets the HttpErrorResponse itself (status and body)
 * and no 400/500 alert from here: its caller shows the error.
 */
export const KEEP_HTTP_ERROR = new HttpContextToken<boolean>(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private _authService: AuthService,
    private _alertService: AlertService
  ) { }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    if (this._authService.accessToken) {
      newReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
      });
    }

    // Response
    return next.handle(newReq).pipe(
      catchError((error) => {

        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Log out
          this._authService.logout({ deviceId: this._authService.deviceId });

          // Reload the app
          location.reload();
        }

        // Catch "500 Internal server error" responses
        const keep = req.context.get(KEEP_HTTP_ERROR);
        if (!keep && error instanceof HttpErrorResponse && (error.status === 500 || error.status === 400)) {
          this._alertService.showValidationErrors(error.error?.message);
        }

        return throwError(() => (keep ? error : new Error(error)));
      })
    );
  }
}
